import { Splitter } from 'antd'
import { createStyles } from 'antd-style'

import { DocBreadcrumb } from './components/Breadcrumb'
import { DocContent } from './components/Content'
import { DocMenu } from './components/Menu'
import { HomeStoreProvider } from './Store'

const useStyles = createStyles(({ token }) => ({
  leftPanel: {
    maxHeight: '70vh',
    overflow: 'auto'
  },
  rightPanel: {
    backgroundColor: token.colorWhite
  },
  contentWrapper: {
    paddingInline: token.paddingSM
  }
}))

export const HomePage = () => {
  const { styles } = useStyles()

  return (
    <HomeStoreProvider>
      <Splitter>
        <Splitter.Panel
          className={styles.leftPanel}
          defaultSize={300}
          max={400}
          min={200}
        >
          <DocMenu />
        </Splitter.Panel>
        <Splitter.Panel className={styles.rightPanel}>
          <div className={styles.contentWrapper}>
            <DocBreadcrumb />
            <DocContent />
          </div>
        </Splitter.Panel>
      </Splitter>
    </HomeStoreProvider>
  )
}
